import { useNavigate } from 'react-router-dom';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { AffiliateUserSummary } from '../../interfaces/AffiliateUserSummary/AffiliateUserSummary';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { PriceColumn } from '../../components/DataTable/PriceColumn';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { BoolColumn } from '../../components/DataTable/BoolColumn';

const columns: TableColumn<AffiliateUserSummary>[] = [
  {
    id: 'user-id',
    name: 'Kullanıcı ID',
    accessor: (row) => <TextColumn value={row.userID.toString()} />,
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => (
      <TextColumn value={`${row.firstName} ${row.lastName}`} />
    ),
  },
  {
    id: 'email',
    name: 'Email',
    accessor: (row) => <TextColumn value={row.email} />,
  },
  {
    id: 'phone',
    name: 'Telefon',
    accessor: (row) => <TextColumn value={row.phone} />,
  },
  {
    id: 'affiliate-code',
    name: 'Affiliate Kodu',
    accessor: (row) => <TextColumn value={row.affiliateCode} />,
  },
  {
    id: 'affiliate-enabled',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.affiliateEnabled} />,
  },
  {
    id: 'total-clicks',
    name: 'Tıklanma',
    accessor: (row) => <TextColumn value={row.totalClicks.toString()} />,
  },
  {
    id: 'total-unique-clicks',
    name: 'Tekil Tıklanma',
    accessor: (row) => <TextColumn value={row.totalUniqueClicks.toString()} />,
  },
  {
    id: 'total-orders',
    name: 'Sipariş',
    accessor: (row) => <TextColumn value={row.totalOrders.toString()} />,
  },
  {
    id: 'total-revenue',
    name: 'Gelir',
    accessor: (row) => <PriceColumn value={row.totalRevenue} />,
  },
];

type AffiliateUsersTableProps = {
  affiliates: AffiliateUserSummary[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const AffiliateUsersTable = (props: AffiliateUsersTableProps) => {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.affiliates}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      onClick={(user) => navigate(`/users/affiliate/${user.userID}`)}
    />
  );
};
